import React from 'react'

export const ServicesContext = React.createContext()
